export function isSalesInActive(
  asofDate: string,
  assignClosingDate: string
): boolean {
  if (asofDate === "" || assignClosingDate === "") {
    return false;
  }
  const d1 = new Date(assignClosingDate);
  const d2 = removeMonths(24, new Date(asofDate));
  return d1 < d2;
}

function removeMonths(month: number, datetoReduce: Date) {
  const d = datetoReduce;
  const years = Math.floor(month / 12);
  const months = month - years * 12;
  if (years) {
    d.setFullYear(d.getFullYear() - years);
  }
  if (months) {
    d.setMonth(d.getMonth() - months);
  }
  return d;
}
